import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
  import { switchMap } from 'rxjs/operators';
  import { UtilHelper } from '../../../_helpers/util';
  import { environment } from '../../../../environments/environment';
  import { Router, ActivatedRoute, ParamMap } from '@angular/router';
  import { OperacionService, GeneralService, IndicadorProgramacionService, SeguimientoPsdiService } from '../../../services/service.index';
  import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxComponent, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
  import { formatDate } from '@angular/common';
  declare var jQuery: any;
  declare var toastr;

@Component({
  selector: 'app-seguimiento-psdi',
  templateUrl: './seguimiento-psdi.component.html',
  styleUrls: []
})
export class SeguimientoPsdiComponent implements OnInit {
   
    @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
    @ViewChild(DxSelectBoxComponent) selectBox: DxSelectBoxComponent
    adjuntar: string = '';
    justificar: string = '';
    titulo: string = '';
    esLectura: boolean = false;
    clicked: boolean = false;
    baseUrl = environment.apiEndpoint;
    baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
    file: File = null;
    maxFileSize = 2097152;
    typeFiles = ['application/pdf', 'image/jpeg', 'image/png', 'text/csv', 'text/xlsx', 'text/xls', '.xls', '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
    hasError: any;
    hasErrorAcp: any;
    poaTecho: any;
    operaciones: any = [];
    indicadores: any[];
    lstIndicadorACP: any[];
    indicador: any = { id: 0, medio_verificacion: '', meta: '', tipo_indicador: '', unidad_medida: '', variables: [] };
    nombre_variable: string = '';
    lstVariableMes: any[] = [];
    lstEstados: any[] = [];
    listMeses: any[] = [];
    techoId: string = '0';
    popupVisibleAdd: boolean = false;
    popupVisibleAddAcp: boolean = false;
    popupVisibleReportarEditar: boolean = false;
    popupCambiarEstado: boolean = false;
    popupObservar: boolean = false;
    popupVisibleDel: boolean = false;
    popupVisibleDelAcp: boolean = false;
    dateActual: Date = new Date();
    mesReporte: any = {};
    model: any = { id: 0, indicador_id: 0, valor_variable: '', mes_id: 0, mes: '', variable_id: 0, variable: '', medio_verificacion: '', justificacion: '', resultados_esperados: '', reportado_mes: 0 };
    modelAcp: any = { id: 0, indicador_id: 0, valor_variable: '', mes_id: 0, mes: '', indicador_acp_id: 0, variable: '', justificacion: '', resultados_esperados: '', reportado_mes: 0 };
    estadoCambiar: any[] = [{ id: 33, descripcion: 'REVISADO' }, { id: 34, descripcion: 'APRUEBA' }];
    variableMes: any = {};
    idVariableMes: number = 0;
    metaGestion: number = 0;
    mesId: number = 0;
    rol: number = 0;
    userId: number = 0;
    diaLimite: number = 0;
    estado: number = 32;
    acp: string = '';
    indicador_acp: string;
    meta_acp: number = 0;
    resultadoTexto: string;
    accionTexto: string;
    indicadorTexto: string;
    metaMes: number;
    tituloAprobar: string = '';
    mes_nombre: string = '';
    mesAreportar: number = 0;
    fechaActual: Date = new Date();
    medioVerificacion: string = "";
  
    idIndicador: number;
    modelProgramacion: any = {
      id: 0,
      variable1: '',
      variable2: '',
      indicador_id: 0,
      meta: '',
      meses: [],
    }
    OpDescripcion: string;
    popupVisibleP: boolean = false;
    lsIndicadoresMes: any = [];
    lsMeses: any = [];
  
    constructor(private route: ActivatedRoute, private _gs: GeneralService, private _os: OperacionService, private _ss: SeguimientoPsdiService, private _iop: IndicadorProgramacionService) {
      //this.route.paramMap.pipe(switchMap((params: ParamMap) => this.techoId = params.get('id'))).subscribe();
      this.metaGestion = JSON.parse(localStorage.getItem('g'));
      let u = JSON.parse(localStorage.getItem('u'));
      this.rol = u.rol;
      this.userId = u.id;
  
      if (this.rol == 21) {
        this.tituloAprobar = 'Enviar a Revisión';
      }
      if ((this.rol == 22) || (this.rol == 23) || (this.rol == 24)) {
        this.tituloAprobar = 'Aprobar';
      }
      this.listaMeses();
      this.getDiaAreportar();
      this._ss.getMesDeReporte().subscribe(
        (Response) => {
          let result = UtilHelper.responses(Response);
          if (result.status == 200) {
            this.mesId = result.data.id;
            this.model.mes = result.data.mes;
            this.model.mes_id = result.data.id;
            this.modelAcp.mes_id = result.data.id;
            this.mesId = result.data.id;
            this.mes_nombre = result.data.mes;
            this.mesAreportar = result.data.id;
          }
        }
      );
  
    }
  
  
  
    ngOnInit() {
    }
  
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'before',
        template: 'acciones'
      },
        // {
        //   location: 'before',
        //   widget: 'dxButton',
        //   options: {
        //     icon: 'refresh',
        //     text: 'Actualizar',
        //     onClick: this.refreshDataGridAcp.bind(this)
        //   }
        // }
        );
    }
  
    refreshDataGridAcp(e) {
      this.mesId = e.value;
      this.getIndicadorUser();    
      this.dataGrid.instance.refresh();
    }
  
    getIndicadorUser() {      
      this._ss.getIndicadorUser(this.userId, this.mesId).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {                      
            this.lstVariableMes = result.data;          
          }
          else { this.lstVariableMes = []; }
        },
        (error) => { console.log('Error', error); });
    }
  
    listaMeses() {
      this._ss.getListaMeses().subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.listMeses = result.data;
          }
          else {
            this.listMeses = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  
    getDiaAreportar() {
      this._ss.getDiaDeReporte().subscribe(
        (Response) => {
          let result = UtilHelper.responses(Response);
          if (result.status == 200) {
            this.diaLimite = result.data.sigla;
          }
        }
      );
    }
  
    showModalAdd(indicador_id: string, resultadoTexto: string, accionTexto: string, indicadorTexto: string) {
      this.resetErrors();
      if (this.validaGestion()) {
        this.file = null;
        jQuery("#file").val('');
        this.indicador = {};
        this.model.indicador_id = indicador_id;      
        this.resultadoTexto = resultadoTexto;
        this.accionTexto = accionTexto;
        this.indicadorTexto = indicadorTexto;
        this.idVariableMes = 0;
        this.model.id = 0;
  
        this.model.valor_variable = '';
        this.model.resultados_esperados = '';
        this.model.medio_verificacion = '';
        this.model.justificacion = '';
        this.model.file = '';        
        this.getDatosIndicador(indicador_id);
      }
    }
  
    resetErrors() {
      this.hasError = { justificacion: false, medio_verificacion: false, resultados_esperados: false, valor_variable: false, file: false };
    }
  
    validaGestion() {
      let res = true; let f1: boolean = false, f2: boolean = false, f3: boolean = false;
      if (this.metaGestion != this.fechaActual.getFullYear()) { res = false; f1 = true; }
      if (this.mesId != this.mesAreportar) { res = false; f2 = true; }
      if (this.fechaActual.getDate() > this.diaLimite) { res = false; f3 = true; }
  
      if (f1 == true)
        toastr.warning('Debe cambiar a la Gestión ' + this.dateActual.getFullYear() + ' para reportar sus avances');
      if (f2 == true)
        toastr.warning('El mes de reporte habilitado es ' + this.mes_nombre + ', seleccione correctamente el mes');
      if (f3 == true)
        toastr.warning('El ' + this.diaLimite + ' de ' + ' fue el día límite para reportar sus avances');
      return res;
    }
  
    getDatosIndicador(e: string) {
      this.resetErrors();
  
      this._ss.getIndicadorPdesById(e).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.indicador = result.data;            
            this.medioVerificacion = result.data[0].medio_verificacion;
            if (result.data[0].variables.length == 0) {
              toastr.warning('No tiene registradado su programación mensual de avance ');
              this.indicador = [];
            }
            else {
  
              this.model.indicador_id = e;
              this.getProgramadoMes(this.model.indicador_id, this.mesId);
              this.metaMes = this.indicador[0].meta;
              this.nombre_variable = this.indicador[0].variables[0].variable;
              this.model.variable_id = this.indicador[0].variables[0].id_variable;
              this.popupVisibleAdd = true;
            }
  
          }
          else {
            this.indicador = [];
          }
        },
        (error) => { console.log('Error', error); });
  
    }
  
    getProgramadoMes(indicador_id: string, mes_id: number) {
      this._ss.getMetaProgramada(indicador_id, mes_id).subscribe(
        (Response) => {
          let result = UtilHelper.responses(Response);
          if (result.status == 200) {            
            this.model.reportado_mes = result.data;
          }
        }
      );
    }
  
    refreshAdjuntar(e: any) {
      if (e.value > 0) {
        this.justificar = '';
        this.adjuntar = 'required';
      }
      else {
        this.adjuntar = '';
        this.justificar = 'required';
      }
    }
  
    registrarReporteMes() {
      this.resetErrors();
      if (this.validSave()) {
        if (this.idVariableMes == 0) {
          this.model.id = 0;
          this._ss.postReportarMes(this.model, this.file).subscribe(
            response => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                this.getIndicadorUser();
                toastr.success('Datos guardados correctamente.');
                this.clicked = false;
              }
              if (result.status == 201) {
                toastr.warning(result.data);
                this.clicked = false;
              }
              this.popupVisibleAdd = false;
            });
        }
        else {
          this._ss.putReportarMes(this.model, this.file).subscribe(
            response => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                this.getIndicadorUser();
                toastr.success('Datos guardados correctamente.');
                this.clicked = false;
                this.popupVisibleReportarEditar = false;
              }
              if (result.status == 201) {
                toastr.warning(result.data);
                this.clicked = false;
                this.popupVisibleReportarEditar = false;
              }
            });
        }
      }
    }
  
    validSave() {
      let res = true;
      if (!UtilHelper.validator(this.model.resultados_esperados, 'text')) {
        this.hasError.resultados_esperados = true; res = false;
      }
      // if (!UtilHelper.validator(this.model.medio_verificacion, 'text')) {
      //   this.hasError.medio_verificacion = true; res = false;
      // }
      // if (!UtilHelper.validator(this.model.justificacion, 'text')) {
      //   this.hasError.justificacion = true; res = false;
      // }
      if (!UtilHelper.validator(this.model.valor_variable, 0) || (this.model.valor_variable != 0) && (this.model.valor_variable < 1)) {
        this.hasError.valor_variable = true; res = false;
      }
  
      if (this.adjuntar == 'required') {
        if (this.file != null) {
          if (this.file.size > this.maxFileSize) {
            toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
            this.hasError.file = true; res = false;
          }
          if (this.typeFiles.indexOf(this.file.type) == -1) {
            toastr.warning('Formato de archivo no válido, los permitidos son PDF, JPG y PNG.');
            this.hasError.file = true; res = false;
          }
        }
        else {
          toastr.warning('Debe adjuntar un documento de respaldo');
          this.hasError.file = true; res = false;
        }
      }
      
      return res;
    }
  
    handleFileInput(files: FileList) {
      this.file = files.item(0);
      if (this.file != null) {
        if (this.file.size > this.maxFileSize) {
          toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
        }
        if (this.typeFiles.indexOf(this.file.type) == -1) {
          toastr.warning('Formato de archivo no válido, los permitidos son PDF, JPG, PNG, DOC, DOCX, XLS, XLSX.');
        }
      }
    }
  
    resetModel() {
      this.model = { id: 0, justificacion: '', medio_verificacion: '', resultados_esperados: '', valor_variable: '', file: null };
    }
  
  
    showModalDelete(id: number) {
      this.idVariableMes = id;
      this.popupVisibleDel = true;
    }
  
    deleteAvance() {
      this._ss.deleteSeguimiento(this.idVariableMes).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.popupVisibleDel = false;
            this.getIndicadorUser();
            toastr.success('Operación realizada exitosamente.');
          } else {
            toastr.warning('Ocurrió un inconveniente al eliminar el registro.');
          }
        },
        error => { console.log('Error', error); });
    }
  
    editarVariableMes(id: string, esLectura: boolean) {
      this.esLectura = esLectura;
      if (this.esLectura == true)
        this.titulo = 'DATOS DEL SEGUIMIENTO';
      else
        this.titulo = 'EDITAR DATOS DEL SEGUIMIENTO';
  
      this.idVariableMes = parseInt(id);
      this._ss.getVariableMesById(id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.variableMes = result.data;
            this.getProgramadoMes(this.variableMes.indicador_id, this.variableMes.mes_id);
            this.model.justificacion = this.variableMes.justificacion;
            this.model.resultados_esperados = this.variableMes.resultados_esperados;
            this.model.valor_variable = this.variableMes.valor_variable;
            this.model.variable_id = this.variableMes.variable_id;
            this.model.variable = this.variableMes.variable;
            this.model.mes_id = this.variableMes.mes_id;
            this.model.mes = this.variableMes.mes;
            this.model.tipo_indicador = this.variableMes.tipo_indicador;
            this.model.meta = this.variableMes.meta;
            this.model.medio_verificacion = this.variableMes.cite_medio_verificacion;
            this.model.id = this.idVariableMes;
            this.nombre_variable = this.variableMes.variable;
            this.resetErrors();
            this.popupVisibleReportarEditar = true;
  
          }
          else { this.variableMes = []; }
        },
        (error) => { console.log('Error', error); });
    }  
  
  
    showModalCambiarEstado(id: number) {
      this.popupCambiarEstado = true;
      this.model.idVariableMes = id;
  
  
    }
    showModalObservar(id: number) {
      this.popupObservar = true;
      this.model.idVariableMes = id;
    }
  
    aprobarEstado() {
  
      this._ss.putActualizarEstadoSeguimiento(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
  
            this.getIndicadorUser();
            toastr.success('Datos guardados correctamente.');
            this.popupCambiarEstado = false;
          }
          else {
            toastr.warning(result.data);
            this.popupCambiarEstado = false;
          }
        });
    }
  
    observarEstado() {
      this._ss.putObservarSeguimiento(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            toastr.success('Datos guardados correctamente.');
            this.popupObservar = false;
            this.getIndicadorUser();
          }
          else {
            toastr.warning(result.data);
            this.popupObservar = false;
          }
        });
    }
  
  
    /*
    getVariableMesByEstadoId(id: string) {
      this._ss.getVariableMesByEstadoId(this.techoId, id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.lstVariableMes = result.data; }
          else { this.lstVariableMes = []; }
        },
        (error) => { console.log('Error', error); });
    }
  
    
  
    getPoaTecho() {
      this._gs.getPoaTechoById(this.techoId).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.poaTecho = result.data;
          }
          else { this.poaTecho = []; }
        },
        (error) => { console.log('Error', error); });
    }
  
    getVariableMesByTechoId(id: string) {
      this._ss.getVariablesMesByTechoId(id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.lstVariableMes = result.data; }
          else { this.lstVariableMes = []; }
        },
        (error) => { console.log('Error', error); });
    }
  
  
  
    getOperacionesByByTechoId() {
      this._os.getListoperacionesByTechoId(this.techoId).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.operaciones = result.data; }
          else { this.operaciones = []; }
        },
        (error) => { console.log('Error', error); });
    }
  
    getIndicadoresOpByOperacionId(e: any) {
      if (e.value != undefined && e.value != null) {
        this._ss.getIndicadoresOpByOperacionId(e.value).subscribe(
          (response) => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.indicadores = result.data;
            }
            else { this.indicadores = []; }
          },
          (error) => { console.log('Error', error); });
      }
    }
  
    getListACP() {
      this._ss.getListACP(this.techoId, this.mesId).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
  
            this.acp = result.data[0].acp;
            this.lstIndicadorACP = result.data;
          }
          else {
            this.lstIndicadorACP = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  
    
   
  
  
    deleteAvanceAcp() {
      this._ss.deleteSeguimientoAcp(this.modelAcp.id).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.popupVisibleDelAcp = false;
            this.getListACP();
            toastr.success('Operación realizada exitosamente.');
          } else {
            toastr.warning('Ocurrió un inconveniente al eliminar el registro.');
          }
        },
        error => { console.log('Error', error); });
    }
    showModalIndicadorAcp(acp: any) {
      if (this.validaGestion()) {
        this.resetErrorsAcp();
        if (acp.reportado.id == 0) {
          this.resetModelAcp();
        }
        else {
          this.modelAcp.id = acp.reportado.id;
          this.modelAcp.indicador_acp_id = acp.id;
          this.modelAcp.mes_id = acp.reportado.mes_id;
          this.indicador_acp = acp.descripcion;
          this.meta_acp = acp.meta;
          this.modelAcp.valor_variable = acp.reportado.valor_variable;
          this.modelAcp.resultados_esperados = acp.reportado.resultados_esperados;
          this.modelAcp.justificacion = acp.reportado.justificacion;
        }
        this.popupVisibleAddAcp = true;
      }
    }
  
  
    resetErrorsAcp() {
      this.hasErrorAcp = { justificacion: false, medio_verificacion: false, resultados_esperados: false, valor_variable: false, file: false };
    }
    resetModelAcp() {
      this.modelAcp = { id: 0, justificacion: '', medio_verificacion: '', resultados_esperados: '', valor_variable: '', file: null };
    }
  
  
    registrarReporteMesAcp() {
      this.resetErrorsAcp();
      if (this.validSaveAcp()) {
  
        if (this.modelAcp.mes_id != 0)
          this.modelAcp.mes_id = this.mesId;
        this._ss.postReportarMesAcp(this.modelAcp).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getListACP();
              toastr.success('Datos guardados correctamente.');
            }
            else if (result.status == 201) {
              toastr.warning(result.data);
            }
            else {
              toastr.warning('No se pudo registrar...');
            }
            this.popupVisibleAddAcp = false;
          });
  
      }
    }
  
    validSaveAcp() {
      let res = true;
      if (!UtilHelper.validator(this.modelAcp.resultados_esperados, 'text')) {
        this.hasErrorAcp.resultados_esperados = true; res = false;
      }
  
      if (!UtilHelper.validator(this.modelAcp.valor_variable, 0) || (this.modelAcp.valor_variable != 0) && (this.modelAcp.valor_variable < 1)) {
        this.hasErrorAcp.valor_variable = true; res = false;
      }
  
      return res;
    }
  
   
  
    showModalProgramacion(id: number, meta: number, ind: string, op: string) {    
      this.idIndicador = id;
      //this.modelProgramacion.meta = meta;
      this.OpDescripcion = ind;
      this.cargarIndicadorMesPorIndicador();
      this.modelProgramacion.variable1 = op;
      this.popupVisibleP = true;
    }
  
    cargarIndicadorMesPorIndicador() {
      this._iop.getListIndicadoresMesPorIndicador(this.idIndicador)
        .subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.lsIndicadoresMes = result.data;
              this.getListSoloMeses();
  
            }
  
          },
          (error) => { console.log('Error', error); });
    }
  
    getListSoloMeses() {
      this._iop.getListMeses()
        .subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.lsMeses = result.data;
            }
          },
          (error) => { console.log('Error', error); });
    }
  */
  }
  